import { takeEvery, put, call, all, fork } from "redux-saga/effects";
import {
  FOOD_PREORDER_EVENT_LIST,
  FOOD_PREORDER_EVENT_SEARCH,
  FOOD_PREORDER_EVENT_DATA,
  FOOD_PREORDER_EVENT_CREATE,
  FOOD_PREORDER_EVENT_UPDATE,
  FOOD_PREORDER_EVENT_DELETE,
  FOOD_PREORDER_EVENT_GUEST_LIST,
  FOOD_PREORDER_EVENT_GUEST_SEARCH,
  FOOD_PREORDER_EVENT_GUEST_DATA,
  FOOD_PREORDER_EVENT_GUEST_INVITE,
  FOOD_PREORDER_EVENT_GUEST_DELETE,
  FOOD_MENU_STATUS_LIST,
  FOOD_MENU_STATUS_DATA,
  FOOD_MENU_STATUS_CREATE,
  FOOD_MENU_STATUS_UPDATE,
  FOOD_MENU_STATUS_DELETE,
  FOOD_MENU_LIST,
  FOOD_MENU_DATA,
  FOOD_MENU_CREATE,
  FOOD_MENU_UPDATE,
  FOOD_MENU_DELETE,
  FOOD_MENU_CATEGORY_LIST,
  FOOD_MENU_CATEGORY_DATA,
  FOOD_MENU_CATEGORY_CREATE,
  FOOD_MENU_CATEGORY_UPDATE,
  FOOD_MENU_CATEGORY_DELETE,
  FOOD_MENU_ITEM_LIST,
  FOOD_MENU_ITEM_DATA,
  FOOD_MENU_ITEM_CREATE,
  FOOD_MENU_ITEM_UPDATE,
  FOOD_MENU_ITEM_DELETE,
  FOOD_PREORDER_EVENT_STATUS_LIST,
  FOOD_PREORDER_EVENT_STATUS_DATA,
  FOOD_PREORDER_EVENT_STATUS_CREATE,
  FOOD_PREORDER_EVENT_STATUS_UPDATE,
  FOOD_PREORDER_EVENT_STATUS_DELETE,
  FOOD_PREORDER_EVENT_TYPE_LIST,
  FOOD_PREORDER_EVENT_TYPE_DATA,
  FOOD_PREORDER_EVENT_TYPE_CREATE,
  FOOD_PREORDER_EVENT_TYPE_UPDATE,
  FOOD_PREORDER_EVENT_TYPE_DELETE,
  FOOD_MENU_TYPE_LIST,
  FOOD_MENU_TYPE_DATA,
  FOOD_MENU_TYPE_CREATE,
  FOOD_MENU_TYPE_UPDATE,
  FOOD_MENU_TYPE_DELETE,
  FOOD_PREORDER_SITE_LOCATION_LIST,
  FOOD_PREORDER_SITE_LOCATION_DATA,
  FOOD_PREORDER_SITE_LOCATION_CREATE,
  FOOD_PREORDER_SITE_LOCATION_UPDATE,
  FOOD_PREORDER_SITE_LOCATION_DELETE,
  FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE,
  FOOD_PREORDER_EVENT_GUEST_ACCEPT,
  FOOD_PREORDER_EVENT_GUEST_DECLINE,
  FOOD_MENU_SEARCH,
  FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY,
  FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND,
  FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST,
  FOOD_PREORDER_EVENT_COMMUNICATION_LIST,
  FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH,
  FOOD_PREORDER_EVENT_ATTACHMENT_DELETE,
  FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY,
  FOOD_MENU_ITEM_SEARCH,
  FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH,
  FOOD_PREORDER_EVENT_GROUP_LIST,
  FOOD_PREORDER_EVENT_GROUP_DATA,
  FOOD_PREORDER_EVENT_GROUP_CREATE,
  FOOD_PREORDER_EVENT_GROUP_UPDATE,
  FOOD_PREORDER_EVENT_GROUP_DELETE,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA,
  FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS,
  FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST,
  FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST,
  FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE,
  FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE,
  FOOD_PREORDER_SITE_LOCATION_SEARCH,
  FOOD_MENU_CLONE,
} from "./actionType";

import {
  foodPreOrderEventListSuccess,
  foodPreOrderEventListFail,
  foodPreOrderEventSearchSuccess,
  foodPreOrderEventSearchFail,
  foodPreOrderEventDataSuccess,
  foodPreOrderEventDataFail,
  foodPreOrderEventCreateSuccess,
  foodPreOrderEventCreateFail,
  foodPreOrderEventUpdateSuccess,
  foodPreOrderEventUpdateFail,
  foodPreOrderEventDeleteSuccess,
  foodPreOrderEventDeleteFail,
  foodPreOrderEventGuestListSuccess,
  foodPreOrderEventGuestListFail,
  foodPreOrderEventGuestSearchSuccess,
  foodPreOrderEventGuestSearchFail,
  foodPreOrderEventGuestDataSuccess,
  foodPreOrderEventGuestDataFail,
  foodPreOrderEventGuestInviteSuccess,
  foodPreOrderEventGuestInviteFail,
  foodPreOrderEventGuestDeleteSuccess,
  foodPreOrderEventGuestDeleteFail,
  foodMenuStatusListSuccess,
  foodMenuStatusListFail,
  foodMenuStatusDataSuccess,
  foodMenuStatusDataFail,
  foodMenuStatusCreateSuccess,
  foodMenuStatusCreateFail,
  foodMenuStatusUpdateSuccess,
  foodMenuStatusUpdateFail,
  foodMenuStatusDeleteSuccess,
  foodMenuStatusDeleteFail,
  foodMenuListSuccess,
  foodMenuListFail,
  foodMenuDataSuccess,
  foodMenuDataFail,
  foodMenuCreateSuccess,
  foodMenuCreateFail,
  foodMenuUpdateSuccess,
  foodMenuUpdateFail,
  foodMenuDeleteSuccess,
  foodMenuDeleteFail,
  foodMenuCategoryListSuccess,
  foodMenuCategoryListFail,
  foodMenuCategoryDataSuccess,
  foodMenuCategoryDataFail,
  foodMenuCategoryCreateSuccess,
  foodMenuCategoryCreateFail,
  foodMenuCategoryUpdateSuccess,
  foodMenuCategoryUpdateFail,
  foodMenuCategoryDeleteSuccess,
  foodMenuCategoryDeleteFail,
  foodMenuItemListSuccess,
  foodMenuItemListFail,
  foodMenuItemDataSuccess,
  foodMenuItemDataFail,
  foodMenuItemCreateSuccess,
  foodMenuItemCreateFail,
  foodMenuItemUpdateSuccess,
  foodMenuItemUpdateFail,
  foodMenuItemDeleteSuccess,
  foodMenuItemDeleteFail,
  foodPreOrderEventStatusListSuccess,
  foodPreOrderEventStatusListFail,
  foodPreOrderEventStatusDataSuccess,
  foodPreOrderEventStatusDataFail,
  foodPreOrderEventStatusCreateSuccess,
  foodPreOrderEventStatusCreateFail,
  foodPreOrderEventStatusUpdateSuccess,
  foodPreOrderEventStatusUpdateFail,
  foodPreOrderEventStatusDeleteSuccess,
  foodPreOrderEventStatusDeleteFail,
  foodPreOrderEventTypeListSuccess,
  foodPreOrderEventTypeListFail,
  foodPreOrderEventTypeDataSuccess,
  foodPreOrderEventTypeDataFail,
  foodPreOrderEventTypeCreateSuccess,
  foodPreOrderEventTypeCreateFail,
  foodPreOrderEventTypeUpdateSuccess,
  foodPreOrderEventTypeUpdateFail,
  foodPreOrderEventTypeDeleteSuccess,
  foodPreOrderEventTypeDeleteFail,
  foodMenuTypeListSuccess,
  foodMenuTypeListFail,
  foodMenuTypeDataSuccess,
  foodMenuTypeDataFail,
  foodMenuTypeCreateSuccess,
  foodMenuTypeCreateFail,
  foodMenuTypeUpdateSuccess,
  foodMenuTypeUpdateFail,
  foodMenuTypeDeleteSuccess,
  foodMenuTypeDeleteFail,
  foodPreOrderSiteLocationListSuccess,
  foodPreOrderSiteLocationListFail,
  foodPreOrderSiteLocationDataSuccess,
  foodPreOrderSiteLocationDataFail,
  foodPreOrderSiteLocationCreateSuccess,
  foodPreOrderSiteLocationCreateFail,
  foodPreOrderSiteLocationUpdateSuccess,
  foodPreOrderSiteLocationUpdateFail,
  foodPreOrderSiteLocationDeleteSuccess,
  foodPreOrderSiteLocationDeleteFail,
  foodPreOrderEventGuestToFoodMenuItemCreateSuccess,
  foodPreOrderEventGuestToFoodMenuItemCreateFail,
  foodPreOrderEventGuestAcceptSuccess,
  foodPreOrderEventGuestAcceptFail,
  foodPreOrderEventGuestDeclineSuccess,
  foodPreOrderEventGuestDeclineFail,
  foodMenuSearchSuccess,
  foodMenuSearchFail,
  foodPreOrderEventEmailOrganiserEventReadySuccess,
  foodPreOrderEventEmailOrganiserEventReadyFail,
  foodPreOrderEventGuestInviteResendSuccess,
  foodPreOrderEventGuestInviteResendFail,
  foodPreOrderEventPdfGuestListConfirmedSuccess,
  foodPreOrderEventPdfGuestListConfirmedFail,
  foodPreOrderEventPdfKitchenMealPlanSuccess,
  foodPreOrderEventPdfKitchenMealPlanFail,
  foodPreOrderEventPdfTableTentCardsSuccess,
  foodPreOrderEventPdfTableTentCardsFail,
  foodPreOrderEventRecentActivityListSuccess,
  foodPreOrderEventRecentActivityListFail,
  foodPreOrderEventCommunicationListSuccess,
  foodPreOrderEventCommunicationListFail,
  foodPreOrderEventAttachmentSearchSuccess,
  foodPreOrderEventAttachmentSearchFail,
  foodPreOrderEventAttachmentDeleteSuccess,
  foodPreOrderEventAttachmentDeleteFail,
  foodPreOrderEventSmsOrganiserEventReadySuccess,
  foodPreOrderEventSmsOrganiserEventReadyFail,
  foodMenuItemSearchSuccess,
  foodMenuItemSearchFail,
  foodPreOrderEventPdfFrontOfHouseMealPlanSuccess,
  foodPreOrderEventPdfFrontOfHouseMealPlanFail,
  foodPreOrderEventGuestPaymentListSuccess,
  foodPreOrderEventGuestPaymentListFail,
  foodPreOrderEventGuestPaymentSearchSuccess,
  foodPreOrderEventGuestPaymentSearchFail,
  foodPreOrderEventGroupListSuccess,
  foodPreOrderEventGroupListFail,
  foodPreOrderEventGroupDataSuccess,
  foodPreOrderEventGroupDataFail,
  foodPreOrderEventGroupCreateSuccess,
  foodPreOrderEventGroupCreateFail,
  foodPreOrderEventGroupUpdateSuccess,
  foodPreOrderEventGroupUpdateFail,
  foodPreOrderEventGroupDeleteSuccess,
  foodPreOrderEventGroupDeleteFail,
  foodPreOrderEventRecentActivityListDataSuccess,
  foodPreOrderEventRecentActivityListDataFail,
  foodPreOrderEventGroupPdfKitchenMealPlanSuccess,
  foodPreOrderEventGroupPdfKitchenMealPlanFail,
  foodPreOrderEventGroupPdfFrontOfHouseMealPlanSuccess,
  foodPreOrderEventGroupPdfFrontOfHouseMealPlanFail,
  foodPreOrderEventGroupPdfTableTentCardsSuccess,
  foodPreOrderEventGroupPdfTableTentCardsFail,
  foodPreOrderEventGroupPdfGuestListConfirmedSuccess,
  foodPreOrderEventGroupPdfGuestListConfirmedFail,
  foodPreOrderEventGroupPdfTablePlanListSuccess,
  foodPreOrderEventGroupPdfTablePlanListFail,

  //csv
  foodPreOrderEventGroupCsvKitchenMealPlanSuccess,
  foodPreOrderEventGroupCsvKitchenMealPlanFail,
  foodPreOrderEventGroupCsvFrontOfHouseMealPlanSuccess,
  foodPreOrderEventGroupCsvFrontOfHouseMealPlanFail,
  foodPreOrderEventGroupCsvGuestListConfirmedSuccess,
  foodPreOrderEventGroupCsvGuestListConfirmedFail,
  foodPreOrderEventGroupCsvTablePlanListSuccess,
  foodPreOrderEventGroupCsvTablePlanListFail,
  foodPreOrderEventCsvKitchenMealPlanSuccess,
  foodPreOrderEventCsvKitchenMealPlanFail,
  foodPreOrderEventCsvFrontOfHouseMealPlanSuccess,
  foodPreOrderEventCsvFrontOfHouseMealPlanFail,
  foodPreOrderEventCsvGuestListConfirmedSuccess,
  foodPreOrderEventCsvGuestListConfirmedFail,
  foodPreOrderEventGroupCsvDrinkListByTableSuccess,
  foodPreOrderEventGroupCsvDrinkListByTableFail,
  foodPreOrderEventGroupPdfDrinkListByTableSuccess,
  foodPreOrderEventGroupPdfDrinkListByTableFail,
  //FOOD_PREORDER_SITE_LOCATION_SEARCH
  foodPreOrderSiteLocationSearchSuccess,
  foodPreOrderSiteLocationSearchFail,
  //FOOD_MENU_CLONE
  foodMenuCloneSuccess,
  foodMenuCloneFail,
} from "./action";

import {
  foodPreOrderEventListApi,
  foodPreOrderEventSearchApi,
  foodPreOrderEventDataApi,
  foodPreOrderEventCreateApi,
  foodPreOrderEventUpdateApi,
  foodPreOrderEventDeleteApi,
  foodPreOrderEventGuestListApi,
  foodPreOrderEventGuestSearchApi,
  foodPreOrderEventGuestDataApi,
  foodPreOrderEventGuestInviteApi,
  foodPreOrderEventGuestDeleteApi,
  foodMenuStatusListApi,
  foodMenuStatusDataApi,
  foodMenuStatusCreateApi,
  foodMenuStatusUpdateApi,
  foodMenuStatusDeleteApi,
  foodMenuListApi,
  foodMenuDataApi,
  foodMenuCreateApi,
  foodMenuUpdateApi,
  foodMenuDeleteApi,
  foodMenuCategoryListApi,
  foodMenuCategoryDataApi,
  foodMenuCategoryCreateApi,
  foodMenuCategoryUpdateApi,
  foodMenuCategoryDeleteApi,
  foodMenuItemListApi,
  foodMenuItemDataApi,
  foodMenuItemCreateApi,
  foodMenuItemUpdateApi,
  foodMenuItemDeleteApi,
  foodPreOrderEventStatusListApi,
  foodPreOrderEventStatusDataApi,
  foodPreOrderEventStatusCreateApi,
  foodPreOrderEventStatusUpdateApi,
  foodPreOrderEventStatusDeleteApi,
  foodPreOrderEventTypeListApi,
  foodPreOrderEventTypeDataApi,
  foodPreOrderEventTypeCreateApi,
  foodPreOrderEventTypeUpdateApi,
  foodPreOrderEventTypeDeleteApi,
  foodMenuTypeListApi,
  foodMenuTypeDataApi,
  foodMenuTypeCreateApi,
  foodMenuTypeUpdateApi,
  foodMenuTypeDeleteApi,
  foodPreOrderSiteLocationListApi,
  foodPreOrderSiteLocationDataApi,
  foodPreOrderSiteLocationCreateApi,
  foodPreOrderSiteLocationUpdateApi,
  foodPreOrderSiteLocationDeleteApi,
  foodPreOrderEventGuestToFoodMenuItemCreateApi,
  foodPreOrderEventGuestAcceptApi,
  foodPreOrderEventGuestDeclineApi,
  foodMenuSearchApi,
  foodPreOrderEventEmailOrganiserEventReadyApi,
  foodPreOrderEventGuestInviteResendApi,
  foodPreOrderEventPdfGuestListConfirmedApi,
  foodPreOrderEventPdfKitchenMealPlanApi,
  foodPreOrderEventPdfTableTentCardsApi,
  foodPreOrderEventRecentActivityListApi,
  foodPreOrderEventCommunicationListApi,
  foodPreOrderEventAttachmentSearchApi,
  foodPreOrderEventAttachmentDeleteApi,
  foodPreOrderEventSmsOrganiserEventReadyApi,
  foodMenuItemSearchApi,
  foodPreOrderEventPdfFrontOfHouseMealPlanApi,
  foodPreOrderEventGuestPaymentListApi,
  foodPreOrderEventGuestPaymentSearchApi,
  foodPreOrderEventGroupListApi,
  foodPreOrderEventGroupDataApi,
  foodPreOrderEventGroupCreateApi,
  foodPreOrderEventGroupUpdateApi,
  foodPreOrderEventGroupDeleteApi,
  foodPreOrderEventRecentActivityListDataApi,
  foodPreOrderEventGroupPdfKitchenMealPlanApi,
  foodPreOrderEventGroupPdfFrontOfHouseMealPlanApi,
  foodPreOrderEventGroupPdfTableTentCardsApi,
  foodPreOrderEventGroupPdfGuestListConfirmedApi,
  foodPreOrderEventGroupPdfTablePlanListApi,
  //csv
  foodPreOrderEventGroupCsvKitchenMealPlanApi,
  foodPreOrderEventGroupCsvFrontOfHouseMealPlanApi,
  foodPreOrderEventGroupCsvGuestListConfirmedApi,
  foodPreOrderEventGroupCsvTablePlanListApi,
  foodPreOrderEventCsvKitchenMealPlanApi,
  foodPreOrderEventCsvFrontOfHouseMealPlanApi,
  foodPreOrderEventCsvGuestListConfirmedApi,
  foodPreOrderEventGroupCsvDrinkListByTableApi,
  foodPreOrderEventGroupPdfDrinkListByTableApi,
  //FOOD_PREORDER_SITE_LOCATION_SEARCH
  foodPreOrderSiteLocationSearchApi,
  //FOOD_MENU_CLONE
  foodMenuCloneApi,
} from "../../helpers/fakebackend_helper";

// FOOD_PREORDER_EVENT_LIST
function* foodPreOrderEventListSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventListApi, payload);
    yield put(foodPreOrderEventListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventListFail(error));
  }
}

export function* watchFoodPreOrderEventListSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_LIST, foodPreOrderEventListSaga);
}

// FOOD_PREORDER_EVENT_SEARCH
function* foodPreOrderEventSearchSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventSearchApi, payload);
    yield put(foodPreOrderEventSearchSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventSearchFail(error));
  }
}

export function* watchFoodPreOrderEventSearchSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_SEARCH, foodPreOrderEventSearchSaga);
}

// FOOD_PREORDER_EVENT_DATA
function* foodPreOrderEventDataSaga({ payload, token }) {
  try {
    const response = yield call(foodPreOrderEventDataApi, payload, token);
    yield put(foodPreOrderEventDataSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventDataFail(error));
  }
}

export function* watchFoodPreOrderEventDataSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_DATA, foodPreOrderEventDataSaga);
}

// FOOD_PREORDER_EVENT_CREATE
function* foodPreOrderEventCreateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventCreateApi, payload);
    yield put(foodPreOrderEventCreateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventCreateFail(error));
  }
}

export function* watchFoodPreOrderEventCreateSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_CREATE, foodPreOrderEventCreateSaga);
}

// FOOD_PREORDER_EVENT_UPDATE
function* foodPreOrderEventUpdateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventUpdateApi, payload);
    yield put(foodPreOrderEventUpdateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventUpdateFail(error));
  }
}

export function* watchFoodPreOrderEventUpdateSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_UPDATE, foodPreOrderEventUpdateSaga);
}

// FOOD_PREORDER_EVENT_DELETE
function* foodPreOrderEventDeleteSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventDeleteApi, payload);
    yield put(foodPreOrderEventDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventDeleteFail(error));
  }
}

export function* watchFoodPreOrderEventDeleteSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_DELETE, foodPreOrderEventDeleteSaga);
}

// FOOD_PREORDER_EVENT_GUEST_LIST
function* foodPreOrderEventGuestListSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventGuestListApi, payload);
    yield put(foodPreOrderEventGuestListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestListFail(error));
  }
}

export function* watchFoodPreOrderEventGuestListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_LIST,
    foodPreOrderEventGuestListSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_SEARCH
function* foodPreOrderEventGuestSearchSaga({ payload, token }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestSearchApi,
      payload,
      token
    );
    yield put(foodPreOrderEventGuestSearchSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestSearchFail(error));
  }
}

export function* watchFoodPreOrderEventGuestSearchSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_SEARCH,
    foodPreOrderEventGuestSearchSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_DATA
function* foodPreOrderEventGuestDataSaga({ payload, token }) {
  try {
    const response = yield call(foodPreOrderEventGuestDataApi, payload, token);
    yield put(foodPreOrderEventGuestDataSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestDataFail(error));
  }
}

export function* watchFoodPreOrderEventGuestDataSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_DATA,
    foodPreOrderEventGuestDataSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_INVITE
function* foodPreOrderEventGuestInviteSaga({ payload, token }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestInviteApi,
      payload,
      token
    );
    yield put(foodPreOrderEventGuestInviteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestInviteFail(error));
  }
}

export function* watchFoodPreOrderEventGuestInviteSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_INVITE,
    foodPreOrderEventGuestInviteSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_DELETE
function* foodPreOrderEventGuestDeleteSaga({ payload, token }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestDeleteApi,
      payload,
      token
    );
    yield put(foodPreOrderEventGuestDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestDeleteFail(error));
  }
}

export function* watchFoodPreOrderEventGuestDeleteSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_DELETE,
    foodPreOrderEventGuestDeleteSaga
  );
}

// FOOD_MENU_STATUS_LIST
function* foodMenuStatusListSaga({ payload }) {
  try {
    const response = yield call(foodMenuStatusListApi, payload);
    yield put(foodMenuStatusListSuccess(response));
  } catch (error) {
    yield put(foodMenuStatusListFail(error));
  }
}

export function* watchFoodMenuStatusListSaga() {
  yield takeEvery(FOOD_MENU_STATUS_LIST, foodMenuStatusListSaga);
}

// FOOD_MENU_STATUS_DATA
function* foodMenuStatusDataSaga({ payload }) {
  try {
    const response = yield call(foodMenuStatusDataApi, payload);
    yield put(foodMenuStatusDataSuccess(response));
  } catch (error) {
    yield put(foodMenuStatusDataFail(error));
  }
}

export function* watchFoodMenuStatusDataSaga() {
  yield takeEvery(FOOD_MENU_STATUS_DATA, foodMenuStatusDataSaga);
}

// FOOD_MENU_STATUS_CREATE
function* foodMenuStatusCreateSaga({ payload }) {
  try {
    const response = yield call(foodMenuStatusCreateApi, payload);
    yield put(foodMenuStatusCreateSuccess(response));
  } catch (error) {
    yield put(foodMenuStatusCreateFail(error));
  }
}

export function* watchFoodMenuStatusCreateSaga() {
  yield takeEvery(FOOD_MENU_STATUS_CREATE, foodMenuStatusCreateSaga);
}

// FOOD_MENU_STATUS_UPDATE
function* foodMenuStatusUpdateSaga({ payload }) {
  try {
    const response = yield call(foodMenuStatusUpdateApi, payload);
    yield put(foodMenuStatusUpdateSuccess(response));
  } catch (error) {
    yield put(foodMenuStatusUpdateFail(error));
  }
}

export function* watchFoodMenuStatusUpdateSaga() {
  yield takeEvery(FOOD_MENU_STATUS_UPDATE, foodMenuStatusUpdateSaga);
}

// FOOD_MENU_STATUS_DELETE
function* foodMenuStatusDeleteSaga({ payload }) {
  try {
    const response = yield call(foodMenuStatusDeleteApi, payload);
    yield put(foodMenuStatusDeleteSuccess(response));
  } catch (error) {
    yield put(foodMenuStatusDeleteFail(error));
  }
}

export function* watchFoodMenuStatusDeleteSaga() {
  yield takeEvery(FOOD_MENU_STATUS_DELETE, foodMenuStatusDeleteSaga);
}

// FOOD_MENU_LIST
function* foodMenuListSaga() {
  try {
    const response = yield call(foodMenuListApi);
    yield put(foodMenuListSuccess(response));
  } catch (error) {
    yield put(foodMenuListFail(error));
  }
}

export function* watchFoodMenuListSaga() {
  yield takeEvery(FOOD_MENU_LIST, foodMenuListSaga);
}

// FOOD_MENU_DATA
function* foodMenuDataSaga({ payload }) {
  try {
    const response = yield call(foodMenuDataApi, payload);
    yield put(foodMenuDataSuccess(response));
  } catch (error) {
    yield put(foodMenuDataFail(error));
  }
}

export function* watchFoodMenuDataSaga() {
  yield takeEvery(FOOD_MENU_DATA, foodMenuDataSaga);
}

// FOOD_MENU_CREATE
function* foodMenuCreateSaga({ payload }) {
  try {
    const response = yield call(foodMenuCreateApi, payload);
    yield put(foodMenuCreateSuccess(response));
  } catch (error) {
    yield put(foodMenuCreateFail(error));
  }
}

export function* watchFoodMenuCreateSaga() {
  yield takeEvery(FOOD_MENU_CREATE, foodMenuCreateSaga);
}

// FOOD_MENU_UPDATE
function* foodMenuUpdateSaga({ payload }) {
  try {
    const response = yield call(foodMenuUpdateApi, payload);
    yield put(foodMenuUpdateSuccess(response));
  } catch (error) {
    yield put(foodMenuUpdateFail(error));
  }
}

export function* watchFoodMenuUpdateSaga() {
  yield takeEvery(FOOD_MENU_UPDATE, foodMenuUpdateSaga);
}

// FOOD_MENU_DELETE
function* foodMenuDeleteSaga({ payload }) {
  try {
    const response = yield call(foodMenuDeleteApi, payload);
    yield put(foodMenuDeleteSuccess(response));
  } catch (error) {
    yield put(foodMenuDeleteFail(error));
  }
}

export function* watchFoodMenuDeleteSaga() {
  yield takeEvery(FOOD_MENU_DELETE, foodMenuDeleteSaga);
}

// FOOD_MENU_CATEGORY_LIST
function* foodMenuCategoryListSaga({ payload }) {
  try {
    const response = yield call(foodMenuCategoryListApi, payload);
    yield put(foodMenuCategoryListSuccess(response));
  } catch (error) {
    yield put(foodMenuCategoryListFail(error));
  }
}

export function* watchFoodMenuCategoryListSaga() {
  yield takeEvery(FOOD_MENU_CATEGORY_LIST, foodMenuCategoryListSaga);
}

// FOOD_MENU_CATEGORY_DATA
function* foodMenuCategoryDataSaga({ payload }) {
  try {
    const response = yield call(foodMenuCategoryDataApi, payload);
    yield put(foodMenuCategoryDataSuccess(response));
  } catch (error) {
    yield put(foodMenuCategoryDataFail(error));
  }
}

export function* watchFoodMenuCategoryDataSaga() {
  yield takeEvery(FOOD_MENU_CATEGORY_DATA, foodMenuCategoryDataSaga);
}

// FOOD_MENU_CATEGORY_CREATE
function* foodMenuCategoryCreateSaga({ payload }) {
  try {
    const response = yield call(foodMenuCategoryCreateApi, payload);
    yield put(foodMenuCategoryCreateSuccess(response));
  } catch (error) {
    yield put(foodMenuCategoryCreateFail(error));
  }
}

export function* watchFoodMenuCategoryCreateSaga() {
  yield takeEvery(FOOD_MENU_CATEGORY_CREATE, foodMenuCategoryCreateSaga);
}

// FOOD_MENU_CATEGORY_UPDATE
function* foodMenuCategoryUpdateSaga({ payload }) {
  try {
    const response = yield call(foodMenuCategoryUpdateApi, payload);
    yield put(foodMenuCategoryUpdateSuccess(response));
  } catch (error) {
    yield put(foodMenuCategoryUpdateFail(error));
  }
}

export function* watchFoodMenuCategoryUpdateSaga() {
  yield takeEvery(FOOD_MENU_CATEGORY_UPDATE, foodMenuCategoryUpdateSaga);
}

// FOOD_MENU_CATEGORY_DELETE
function* foodMenuCategoryDeleteSaga({ payload }) {
  try {
    const response = yield call(foodMenuCategoryDeleteApi, payload);
    yield put(foodMenuCategoryDeleteSuccess(response));
  } catch (error) {
    yield put(foodMenuCategoryDeleteFail(error));
  }
}

export function* watchFoodMenuCategoryDeleteSaga() {
  yield takeEvery(FOOD_MENU_CATEGORY_DELETE, foodMenuCategoryDeleteSaga);
}

// FOOD_MENU_ITEM_LIST
function* foodMenuItemListSaga({ payload }) {
  try {
    const response = yield call(foodMenuItemListApi, payload);
    yield put(foodMenuItemListSuccess(response));
  } catch (error) {
    yield put(foodMenuItemListFail(error));
  }
}

export function* watchFoodMenuItemListSaga() {
  yield takeEvery(FOOD_MENU_ITEM_LIST, foodMenuItemListSaga);
}

// FOOD_MENU_ITEM_DATA
function* foodMenuItemDataSaga({ payload }) {
  try {
    const response = yield call(foodMenuItemDataApi, payload);
    yield put(foodMenuItemDataSuccess(response));
  } catch (error) {
    yield put(foodMenuItemDataFail(error));
  }
}

export function* watchFoodMenuItemDataSaga() {
  yield takeEvery(FOOD_MENU_ITEM_DATA, foodMenuItemDataSaga);
}

// FOOD_MENU_ITEM_CREATE
function* foodMenuItemCreateSaga({ payload }) {
  try {
    const response = yield call(foodMenuItemCreateApi, payload);
    yield put(foodMenuItemCreateSuccess(response));
  } catch (error) {
    yield put(foodMenuItemCreateFail(error));
  }
}

export function* watchFoodMenuItemCreateSaga() {
  yield takeEvery(FOOD_MENU_ITEM_CREATE, foodMenuItemCreateSaga);
}

// FOOD_MENU_ITEM_UPDATE
function* foodMenuItemUpdateSaga({ payload }) {
  try {
    const response = yield call(foodMenuItemUpdateApi, payload);
    yield put(foodMenuItemUpdateSuccess(response));
  } catch (error) {
    yield put(foodMenuItemUpdateFail(error));
  }
}

export function* watchFoodMenuItemUpdateSaga() {
  yield takeEvery(FOOD_MENU_ITEM_UPDATE, foodMenuItemUpdateSaga);
}

// FOOD_MENU_ITEM_DELETE
function* foodMenuItemDeleteSaga({ payload }) {
  try {
    const response = yield call(foodMenuItemDeleteApi, payload);
    yield put(foodMenuItemDeleteSuccess(response));
  } catch (error) {
    yield put(foodMenuItemDeleteFail(error));
  }
}

export function* watchFoodMenuItemDeleteSaga() {
  yield takeEvery(FOOD_MENU_ITEM_DELETE, foodMenuItemDeleteSaga);
}

// FOOD_PREORDER_EVENT_STATUS_LIST
function* foodPreOrderEventStatusListSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventStatusListApi, payload);
    yield put(foodPreOrderEventStatusListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventStatusListFail(error));
  }
}

export function* watchFoodPreOrderEventStatusListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_STATUS_LIST,
    foodPreOrderEventStatusListSaga
  );
}

// FOOD_PREORDER_EVENT_STATUS_DATA
function* foodPreOrderEventStatusDataSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventStatusDataApi, payload);
    yield put(foodPreOrderEventStatusDataSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventStatusDataFail(error));
  }
}

export function* watchFoodPreOrderEventStatusDataSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_STATUS_DATA,
    foodPreOrderEventStatusDataSaga
  );
}

// FOOD_PREORDER_EVENT_STATUS_CREATE
function* foodPreOrderEventStatusCreateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventStatusCreateApi, payload);
    yield put(foodPreOrderEventStatusCreateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventStatusCreateFail(error));
  }
}

export function* watchFoodPreOrderEventStatusCreateSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_STATUS_CREATE,
    foodPreOrderEventStatusCreateSaga
  );
}

// FOOD_PREORDER_EVENT_STATUS_UPDATE
function* foodPreOrderEventStatusUpdateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventStatusUpdateApi, payload);
    yield put(foodPreOrderEventStatusUpdateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventStatusUpdateFail(error));
  }
}

export function* watchFoodPreOrderEventStatusUpdateSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_STATUS_UPDATE,
    foodPreOrderEventStatusUpdateSaga
  );
}

// FOOD_PREORDER_EVENT_STATUS_DELETE
function* foodPreOrderEventStatusDeleteSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventStatusDeleteApi, payload);
    yield put(foodPreOrderEventStatusDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventStatusDeleteFail(error));
  }
}

export function* watchFoodPreOrderEventStatusDeleteSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_STATUS_DELETE,
    foodPreOrderEventStatusDeleteSaga
  );
}

// FOOD_PREORDER_EVENT_TYPE_LIST
function* foodPreOrderEventTypeListSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventTypeListApi, payload);
    yield put(foodPreOrderEventTypeListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventTypeListFail(error));
  }
}

export function* watchFoodPreOrderEventTypeListSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_TYPE_LIST, foodPreOrderEventTypeListSaga);
}

// FOOD_PREORDER_EVENT_TYPE_DATA
function* foodPreOrderEventTypeDataSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventTypeDataApi, payload);
    yield put(foodPreOrderEventTypeDataSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventTypeDataFail(error));
  }
}

export function* watchFoodPreOrderEventTypeDataSaga() {
  yield takeEvery(FOOD_PREORDER_EVENT_TYPE_DATA, foodPreOrderEventTypeDataSaga);
}

// FOOD_PREORDER_EVENT_TYPE_CREATE
function* foodPreOrderEventTypeCreateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventTypeCreateApi, payload);
    yield put(foodPreOrderEventTypeCreateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventTypeCreateFail(error));
  }
}

export function* watchFoodPreOrderEventTypeCreateSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_TYPE_CREATE,
    foodPreOrderEventTypeCreateSaga
  );
}

// FOOD_PREORDER_EVENT_TYPE_UPDATE
function* foodPreOrderEventTypeUpdateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventTypeUpdateApi, payload);
    yield put(foodPreOrderEventTypeUpdateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventTypeUpdateFail(error));
  }
}

export function* watchFoodPreOrderEventTypeUpdateSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_TYPE_UPDATE,
    foodPreOrderEventTypeUpdateSaga
  );
}

// FOOD_PREORDER_EVENT_TYPE_DELETE
function* foodPreOrderEventTypeDeleteSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventTypeDeleteApi, payload);
    yield put(foodPreOrderEventTypeDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventTypeDeleteFail(error));
  }
}

export function* watchFoodPreOrderEventTypeDeleteSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_TYPE_DELETE,
    foodPreOrderEventTypeDeleteSaga
  );
}

// FOOD_MENU_TYPE_LIST
function* foodMenuTypeListSaga({ payload }) {
  try {
    const response = yield call(foodMenuTypeListApi, payload);
    yield put(foodMenuTypeListSuccess(response));
  } catch (error) {
    yield put(foodMenuTypeListFail(error));
  }
}

export function* watchFoodMenuTypeListSaga() {
  yield takeEvery(FOOD_MENU_TYPE_LIST, foodMenuTypeListSaga);
}

// FOOD_MENU_TYPE_DATA
function* foodMenuTypeDataSaga({ payload }) {
  try {
    const response = yield call(foodMenuTypeDataApi, payload);
    yield put(foodMenuTypeDataSuccess(response));
  } catch (error) {
    yield put(foodMenuTypeDataFail(error));
  }
}

export function* watchFoodMenuTypeDataSaga() {
  yield takeEvery(FOOD_MENU_TYPE_DATA, foodMenuTypeDataSaga);
}

// FOOD_MENU_TYPE_CREATE
function* foodMenuTypeCreateSaga({ payload }) {
  try {
    const response = yield call(foodMenuTypeCreateApi, payload);
    yield put(foodMenuTypeCreateSuccess(response));
  } catch (error) {
    yield put(foodMenuTypeCreateFail(error));
  }
}

export function* watchFoodMenuTypeCreateSaga() {
  yield takeEvery(FOOD_MENU_TYPE_CREATE, foodMenuTypeCreateSaga);
}

// FOOD_MENU_TYPE_UPDATE
function* foodMenuTypeUpdateSaga({ payload }) {
  try {
    const response = yield call(foodMenuTypeUpdateApi, payload);
    yield put(foodMenuTypeUpdateSuccess(response));
  } catch (error) {
    yield put(foodMenuTypeUpdateFail(error));
  }
}

export function* watchFoodMenuTypeUpdateSaga() {
  yield takeEvery(FOOD_MENU_TYPE_UPDATE, foodMenuTypeUpdateSaga);
}

// FOOD_MENU_TYPE_DELETE
function* foodMenuTypeDeleteSaga({ payload }) {
  try {
    const response = yield call(foodMenuTypeDeleteApi, payload);
    yield put(foodMenuTypeDeleteSuccess(response));
  } catch (error) {
    yield put(foodMenuTypeDeleteFail(error));
  }
}

export function* watchFoodMenuTypeDeleteSaga() {
  yield takeEvery(FOOD_MENU_TYPE_DELETE, foodMenuTypeDeleteSaga);
}

// FOOD_PREORDER_SITE_LOCATION_LIST
function* foodPreOrderSiteLocationListSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderSiteLocationListApi, payload);
    yield put(foodPreOrderSiteLocationListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderSiteLocationListFail(error));
  }
}

export function* watchFoodPreOrderSiteLocationListSaga() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_LIST,
    foodPreOrderSiteLocationListSaga
  );
}

// FOOD_PREORDER_SITE_LOCATION_DATA
function* foodPreOrderSiteLocationDataSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderSiteLocationDataApi, payload);
    yield put(foodPreOrderSiteLocationDataSuccess(response));
  } catch (error) {
    yield put(foodPreOrderSiteLocationDataFail(error));
  }
}

export function* watchFoodPreOrderSiteLocationDataSaga() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_DATA,
    foodPreOrderSiteLocationDataSaga
  );
}

// FOOD_PREORDER_SITE_LOCATION_CREATE
function* foodPreOrderSiteLocationCreateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderSiteLocationCreateApi, payload);
    yield put(foodPreOrderSiteLocationCreateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderSiteLocationCreateFail(error));
  }
}

export function* watchFoodPreOrderSiteLocationCreateSaga() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_CREATE,
    foodPreOrderSiteLocationCreateSaga
  );
}

// FOOD_PREORDER_SITE_LOCATION_UPDATE
function* foodPreOrderSiteLocationUpdateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderSiteLocationUpdateApi, payload);
    yield put(foodPreOrderSiteLocationUpdateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderSiteLocationUpdateFail(error));
  }
}

export function* watchFoodPreOrderSiteLocationUpdateSaga() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_UPDATE,
    foodPreOrderSiteLocationUpdateSaga
  );
}

// FOOD_PREORDER_SITE_LOCATION_DELETE
function* foodPreOrderSiteLocationDeleteSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderSiteLocationDeleteApi, payload);
    yield put(foodPreOrderSiteLocationDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderSiteLocationDeleteFail(error));
  }
}

export function* watchFoodPreOrderSiteLocationDeleteSaga() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_DELETE,
    foodPreOrderSiteLocationDeleteSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE
function* foodPreOrderEventGuestToFoodMenuItemCreateSaga({ payload, token }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestToFoodMenuItemCreateApi,
      payload,
      token
    );
    yield put(foodPreOrderEventGuestToFoodMenuItemCreateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestToFoodMenuItemCreateFail(error));
  }
}

export function* watchFoodPreOrderEventGuestToFoodMenuItemCreateSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE,
    foodPreOrderEventGuestToFoodMenuItemCreateSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_ACCEPT
function* foodPreOrderEventGuestAcceptSaga({ payload, token }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestAcceptApi,
      payload,
      token
    );
    yield put(foodPreOrderEventGuestAcceptSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestAcceptFail(error));
  }
}

export function* watchFoodPreOrderEventGuestAcceptSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_ACCEPT,
    foodPreOrderEventGuestAcceptSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_DECLINE
function* foodPreOrderEventGuestDeclineSaga({ payload, token }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestDeclineApi,
      payload,
      token
    );
    yield put(foodPreOrderEventGuestDeclineSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestDeclineFail(error));
  }
}

export function* watchFoodPreOrderEventGuestDeclineSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_DECLINE,
    foodPreOrderEventGuestDeclineSaga
  );
}

// FOOD_MENU_SEARCH
function* foodMenuSearchSaga({ payload, token }) {
  try {
    const response = yield call(foodMenuSearchApi, payload, token);
    yield put(foodMenuSearchSuccess(response));
  } catch (error) {
    yield put(foodMenuSearchFail(error));
  }
}

export function* watchFoodMenuSearchSaga() {
  yield takeEvery(FOOD_MENU_SEARCH, foodMenuSearchSaga);
}

// FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY
function* foodPreOrderEventEmailOrganiserEventReadySaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventEmailOrganiserEventReadyApi,
      payload
    );
    yield put(foodPreOrderEventEmailOrganiserEventReadySuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventEmailOrganiserEventReadyFail(error));
  }
}

export function* watchFoodPreOrderEventEmailOrganiserEventReadySaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY,
    foodPreOrderEventEmailOrganiserEventReadySaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND
function* foodPreOrderEventGuestInviteResendSaga({ payload, token }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestInviteResendApi,
      payload,
      token
    );
    yield put(foodPreOrderEventGuestInviteResendSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestInviteResendFail(error));
  }
}

export function* watchFoodPreOrderEventGuestInviteResendSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND,
    foodPreOrderEventGuestInviteResendSaga
  );
}

// FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED
function* foodPreOrderEventPdfGuestListConfirmedSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventPdfGuestListConfirmedApi,
      payload
    );
    yield put(foodPreOrderEventPdfGuestListConfirmedSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventPdfGuestListConfirmedFail(error));
  }
}

export function* watchFoodPreOrderEventPdfGuestListConfirmedSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED,
    foodPreOrderEventPdfGuestListConfirmedSaga
  );
}

// FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN
function* foodPreOrderEventPdfKitchenMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventPdfKitchenMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventPdfKitchenMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventPdfKitchenMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventPdfKitchenMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN,
    foodPreOrderEventPdfKitchenMealPlanSaga
  );
}

// FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS
function* foodPreOrderEventPdfTableTentCardsSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventPdfTableTentCardsApi, payload);
    yield put(foodPreOrderEventPdfTableTentCardsSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventPdfTableTentCardsFail(error));
  }
}

export function* watchFoodPreOrderEventPdfTableTentCardsSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS,
    foodPreOrderEventPdfTableTentCardsSaga
  );
}

// FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST
function* foodPreOrderEventRecentActivityListSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventRecentActivityListApi,
      payload
    );
    yield put(foodPreOrderEventRecentActivityListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventRecentActivityListFail(error));
  }
}

export function* watchFoodPreOrderEventRecentActivityListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST,
    foodPreOrderEventRecentActivityListSaga
  );
}

// FOOD_PREORDER_EVENT_COMMUNICATION_LIST
function* foodPreOrderEventCommunicationListSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventCommunicationListApi,
      payload
    );
    yield put(foodPreOrderEventCommunicationListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventCommunicationListFail(error));
  }
}

export function* watchFoodPreOrderEventCommunicationListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_COMMUNICATION_LIST,
    foodPreOrderEventCommunicationListSaga
  );
}

// FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH
function* foodPreOrderEventAttachmentSearchSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventAttachmentSearchApi, payload);
    yield put(foodPreOrderEventAttachmentSearchSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventAttachmentSearchFail(error));
  }
}

export function* watchFoodPreOrderEventAttachmentSearchSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH,
    foodPreOrderEventAttachmentSearchSaga
  );
}

// FOOD_PREORDER_EVENT_ATTACHMENT_DELETE
function* foodPreOrderEventAttachmentDeleteSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventAttachmentDeleteApi, payload);
    yield put(foodPreOrderEventAttachmentDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventAttachmentDeleteFail(error));
  }
}

export function* watchFoodPreOrderEventAttachmentDeleteSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_ATTACHMENT_DELETE,
    foodPreOrderEventAttachmentDeleteSaga
  );
}

// FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY
function* foodPreOrderEventSmsOrganiserEventReadySaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventSmsOrganiserEventReadyApi,
      payload
    );
    yield put(foodPreOrderEventSmsOrganiserEventReadySuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventSmsOrganiserEventReadyFail(error));
  }
}

export function* watchFoodPreOrderEventSmsOrganiserEventReadySaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY,
    foodPreOrderEventSmsOrganiserEventReadySaga
  );
}

// food menu item
function* foodMenuItemSearchSaga({ payload, token }) {
  try {
    const response = yield call(foodMenuItemSearchApi, payload, token);
    yield put(foodMenuItemSearchSuccess(response));
  } catch (error) {
    yield put(foodMenuItemSearchFail(error));
  }
}

export function* watchFoodMenuItemSearchSaga() {
  yield takeEvery(FOOD_MENU_ITEM_SEARCH, foodMenuItemSearchSaga);
}

// FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN
function* foodPreOrderEventPdfFrontOfHouseMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventPdfFrontOfHouseMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventPdfFrontOfHouseMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventPdfFrontOfHouseMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventPdfFrontOfHouseMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
    foodPreOrderEventPdfFrontOfHouseMealPlanSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST
function* foodPreOrderEventGuestPaymentListSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventGuestPaymentListApi, payload);
    yield put(foodPreOrderEventGuestPaymentListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestPaymentListFail(error));
  }
}

export function* watchFoodPreOrderEventGuestPaymentListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST,
    foodPreOrderEventGuestPaymentListSaga
  );
}

// FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH
function* foodPreOrderEventGuestPaymentSearchSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGuestPaymentSearchApi,
      payload
    );
    yield put(foodPreOrderEventGuestPaymentSearchSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGuestPaymentSearchFail(error));
  }
}

export function* watchFoodPreOrderEventGuestPaymentSearchSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH,
    foodPreOrderEventGuestPaymentSearchSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_LIST
function* foodPreOrderEventGroupListSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventGroupListApi, payload);
    yield put(foodPreOrderEventGroupListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupListFail(error));
  }
}

export function* watchFoodPreOrderEventGroupListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_LIST,
    foodPreOrderEventGroupListSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_DATA
function* foodPreOrderEventGroupDataSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventGroupDataApi, payload);
    yield put(foodPreOrderEventGroupDataSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupDataFail(error));
  }
}

export function* watchFoodPreOrderEventGroupDataSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_DATA,
    foodPreOrderEventGroupDataSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_CREATE
function* foodPreOrderEventGroupCreateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventGroupCreateApi, payload);
    yield put(foodPreOrderEventGroupCreateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupCreateFail(error));
  }
}

export function* watchFoodPreOrderEventGroupCreateSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_CREATE,
    foodPreOrderEventGroupCreateSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_UPDATE
function* foodPreOrderEventGroupUpdateSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventGroupUpdateApi, payload);
    yield put(foodPreOrderEventGroupUpdateSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupUpdateFail(error));
  }
}

export function* watchFoodPreOrderEventGroupUpdateSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_UPDATE,
    foodPreOrderEventGroupUpdateSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_DELETE
function* foodPreOrderEventGroupDeleteSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderEventGroupDeleteApi, payload);
    yield put(foodPreOrderEventGroupDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupDeleteFail(error));
  }
}

export function* watchFoodPreOrderEventGroupDeleteSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_DELETE,
    foodPreOrderEventGroupDeleteSaga
  );
}

//FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA GROUP
function* foodPreOrderEventRecentActivityListDataSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventRecentActivityListDataApi,
      payload
    );
    yield put(foodPreOrderEventRecentActivityListDataSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventRecentActivityListDataFail(error));
  }
}

export function* watchFoodPreOrderEventRecentActivityListDataSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA,
    foodPreOrderEventRecentActivityListDataSaga
  );
}

// FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN
function* foodPreOrderEventGroupPdfKitchenMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupPdfKitchenMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventGroupPdfKitchenMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupPdfKitchenMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventGroupPdfKitchenMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN,
    foodPreOrderEventGroupPdfKitchenMealPlanSaga
  );
}

// FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS
function* foodPreOrderEventGroupPdfTableTentCardsSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupPdfTableTentCardsApi,
      payload
    );
    yield put(foodPreOrderEventGroupPdfTableTentCardsSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupPdfTableTentCardsFail(error));
  }
}

export function* watchFoodPreOrderEventGroupPdfTableTentCardsSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS,
    foodPreOrderEventGroupPdfTableTentCardsSaga
  );
}

// FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN
function* foodPreOrderEventGroupPdfFrontOfHouseMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupPdfFrontOfHouseMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventGroupPdfFrontOfHouseMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupPdfFrontOfHouseMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventGroupPdfFrontOfHouseMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
    foodPreOrderEventGroupPdfFrontOfHouseMealPlanSaga
  );
}

// FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED
function* foodPreOrderEventGroupPdfGuestListConfirmedSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupPdfGuestListConfirmedApi,
      payload
    );
    yield put(foodPreOrderEventGroupPdfGuestListConfirmedSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupPdfGuestListConfirmedFail(error));
  }
}

export function* watchFoodPreOrderEventGroupPdfGuestListConfirmedSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED,
    foodPreOrderEventGroupPdfGuestListConfirmedSaga
  );
}

// FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST
function* foodPreOrderEventGroupPdfTablePlanListSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupPdfTablePlanListApi,
      payload
    );
    yield put(foodPreOrderEventGroupPdfTablePlanListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupPdfTablePlanListFail(error));
  }
}

export function* watchFoodPreOrderEventGroupPdfTablePlanListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST,
    foodPreOrderEventGroupPdfTablePlanListSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN
function* foodPreOrderEventGroupCsvKitchenMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupCsvKitchenMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventGroupCsvKitchenMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupCsvKitchenMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventGroupCsvKitchenMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN,
    foodPreOrderEventGroupCsvKitchenMealPlanSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN
function* foodPreOrderEventGroupCsvFrontOfHouseMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupCsvFrontOfHouseMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventGroupCsvFrontOfHouseMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupCsvFrontOfHouseMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventGroupCsvFrontOfHouseMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
    foodPreOrderEventGroupCsvFrontOfHouseMealPlanSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED
function* foodPreOrderEventGroupCsvGuestListConfirmedSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupCsvGuestListConfirmedApi,
      payload
    );
    yield put(foodPreOrderEventGroupCsvGuestListConfirmedSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupCsvGuestListConfirmedFail(error));
  }
}

export function* watchFoodPreOrderEventGroupCsvGuestListConfirmedSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED,
    foodPreOrderEventGroupCsvGuestListConfirmedSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST
function* foodPreOrderEventGroupCsvTablePlanListSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupCsvTablePlanListApi,
      payload
    );
    yield put(foodPreOrderEventGroupCsvTablePlanListSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupCsvTablePlanListFail(error));
  }
}

export function* watchFoodPreOrderEventGroupCsvTablePlanListSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST,
    foodPreOrderEventGroupCsvTablePlanListSaga
  );
}
//FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN
function* foodPreOrderEventCsvKitchenMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventCsvKitchenMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventCsvKitchenMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventCsvKitchenMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventCsvKitchenMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN,
    foodPreOrderEventCsvKitchenMealPlanSaga
  );
}
//FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN
function* foodPreOrderEventCsvFrontOfHouseMealPlanSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventCsvFrontOfHouseMealPlanApi,
      payload
    );
    yield put(foodPreOrderEventCsvFrontOfHouseMealPlanSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventCsvFrontOfHouseMealPlanFail(error));
  }
}

export function* watchFoodPreOrderEventCsvFrontOfHouseMealPlanSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
    foodPreOrderEventCsvFrontOfHouseMealPlanSaga
  );
}
//FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED
function* foodPreOrderEventCsvGuestListConfirmedSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventCsvGuestListConfirmedApi,
      payload
    );
    yield put(foodPreOrderEventCsvGuestListConfirmedSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventCsvGuestListConfirmedFail(error));
  }
}

export function* watchFoodPreOrderEventCsvGuestListConfirmedSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED,
    foodPreOrderEventCsvGuestListConfirmedSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE
function* foodPreOrderEventGroupCsvDrinkListByTableSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupCsvDrinkListByTableApi,
      payload
    );
    yield put(foodPreOrderEventGroupCsvDrinkListByTableSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupCsvDrinkListByTableFail(error));
  }
}

export function* watchFoodPreOrderEventGroupCsvDrinkListByTableSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE,
    foodPreOrderEventGroupCsvDrinkListByTableSaga
  );
}

//FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE
function* foodPreOrderEventGroupPdfDrinkListByTableSaga({ payload }) {
  try {
    const response = yield call(
      foodPreOrderEventGroupPdfDrinkListByTableApi,
      payload
    );
    yield put(foodPreOrderEventGroupPdfDrinkListByTableSuccess(response));
  } catch (error) {
    yield put(foodPreOrderEventGroupPdfDrinkListByTableFail(error));
  }
}

export function* watchFoodPreOrderEventGroupPdfDrinkListByTableSaga() {
  yield takeEvery(
    FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE,
    foodPreOrderEventGroupPdfDrinkListByTableSaga
  );
}

//FOOD_PREORDER_SITE_LOCATION_SEARCH
function* foodPreOrderSiteLocationSearchSaga({ payload }) {
  try {
    const response = yield call(foodPreOrderSiteLocationSearchApi, payload);
    yield put(foodPreOrderSiteLocationSearchSuccess(response));
  } catch (error) {
    yield put(foodPreOrderSiteLocationSearchFail(error));
  }
}

export function* watchFoodPreOrderSiteLocationSearchSaga() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_SEARCH,
    foodPreOrderSiteLocationSearchSaga
  );
}

//FOOD_MENU_CLONE
function* foodMenuCloneSaga({ payload }) {
  try {
    const response = yield call(foodMenuCloneApi, payload);
    yield put(foodMenuCloneSuccess(response));
  } catch (error) {
    yield put(foodMenuCloneFail(error));
  }
}
export function* watchFoodMenuCloneSaga() {
  yield takeEvery(FOOD_MENU_CLONE, foodMenuCloneSaga);
}

function* FoodPreOrderEventsSaga() {
  yield all([
    fork(watchFoodPreOrderEventListSaga),
    fork(watchFoodPreOrderEventSearchSaga),
    fork(watchFoodPreOrderEventDataSaga),
    fork(watchFoodPreOrderEventCreateSaga),
    fork(watchFoodPreOrderEventUpdateSaga),
    fork(watchFoodPreOrderEventDeleteSaga),
    fork(watchFoodPreOrderEventGuestListSaga),
    fork(watchFoodPreOrderEventGuestSearchSaga),
    fork(watchFoodPreOrderEventGuestDataSaga),
    fork(watchFoodPreOrderEventGuestInviteSaga),
    fork(watchFoodPreOrderEventGuestDeleteSaga),
    fork(watchFoodMenuStatusListSaga),
    fork(watchFoodMenuStatusDataSaga),
    fork(watchFoodMenuStatusCreateSaga),
    fork(watchFoodMenuStatusUpdateSaga),
    fork(watchFoodMenuStatusDeleteSaga),
    fork(watchFoodMenuListSaga),
    fork(watchFoodMenuDataSaga),
    fork(watchFoodMenuCreateSaga),
    fork(watchFoodMenuUpdateSaga),
    fork(watchFoodMenuDeleteSaga),
    fork(watchFoodMenuCategoryListSaga),
    fork(watchFoodMenuCategoryDataSaga),
    fork(watchFoodMenuCategoryCreateSaga),
    fork(watchFoodMenuCategoryUpdateSaga),
    fork(watchFoodMenuCategoryDeleteSaga),
    fork(watchFoodMenuItemListSaga),
    fork(watchFoodMenuItemDataSaga),
    fork(watchFoodMenuItemCreateSaga),
    fork(watchFoodMenuItemUpdateSaga),
    fork(watchFoodMenuItemDeleteSaga),
    fork(watchFoodPreOrderEventStatusListSaga),
    fork(watchFoodPreOrderEventStatusDataSaga),
    fork(watchFoodPreOrderEventStatusCreateSaga),
    fork(watchFoodPreOrderEventStatusUpdateSaga),
    fork(watchFoodPreOrderEventStatusDeleteSaga),
    fork(watchFoodPreOrderEventTypeListSaga),
    fork(watchFoodPreOrderEventTypeDataSaga),
    fork(watchFoodPreOrderEventTypeCreateSaga),
    fork(watchFoodPreOrderEventTypeUpdateSaga),
    fork(watchFoodPreOrderEventTypeDeleteSaga),
    fork(watchFoodMenuTypeListSaga),
    fork(watchFoodMenuTypeDataSaga),
    fork(watchFoodMenuTypeCreateSaga),
    fork(watchFoodMenuTypeUpdateSaga),
    fork(watchFoodMenuTypeDeleteSaga),
    fork(watchFoodPreOrderSiteLocationListSaga),
    fork(watchFoodPreOrderSiteLocationDataSaga),
    fork(watchFoodPreOrderSiteLocationCreateSaga),
    fork(watchFoodPreOrderSiteLocationUpdateSaga),
    fork(watchFoodPreOrderSiteLocationDeleteSaga),
    fork(watchFoodPreOrderEventGuestToFoodMenuItemCreateSaga),
    fork(watchFoodPreOrderEventGuestAcceptSaga),
    fork(watchFoodPreOrderEventGuestDeclineSaga),
    fork(watchFoodMenuSearchSaga),
    fork(watchFoodPreOrderEventEmailOrganiserEventReadySaga),
    fork(watchFoodPreOrderEventGuestInviteResendSaga),
    fork(watchFoodPreOrderEventPdfGuestListConfirmedSaga),
    fork(watchFoodPreOrderEventPdfKitchenMealPlanSaga),
    fork(watchFoodPreOrderEventPdfTableTentCardsSaga),
    fork(watchFoodPreOrderEventRecentActivityListSaga),
    fork(watchFoodPreOrderEventCommunicationListSaga),
    fork(watchFoodPreOrderEventAttachmentSearchSaga),
    fork(watchFoodPreOrderEventAttachmentDeleteSaga),
    fork(watchFoodPreOrderEventSmsOrganiserEventReadySaga),
    fork(watchFoodMenuItemSearchSaga),
    fork(watchFoodPreOrderEventPdfFrontOfHouseMealPlanSaga),
    fork(watchFoodPreOrderEventGuestPaymentListSaga),
    fork(watchFoodPreOrderEventGuestPaymentSearchSaga),
    fork(watchFoodPreOrderEventGroupListSaga),
    fork(watchFoodPreOrderEventGroupDataSaga),
    fork(watchFoodPreOrderEventGroupCreateSaga),
    fork(watchFoodPreOrderEventGroupUpdateSaga),
    fork(watchFoodPreOrderEventGroupDeleteSaga),
    fork(watchFoodPreOrderEventRecentActivityListDataSaga),
    fork(watchFoodPreOrderEventGroupPdfKitchenMealPlanSaga),
    fork(watchFoodPreOrderEventGroupPdfTableTentCardsSaga),
    fork(watchFoodPreOrderEventGroupPdfFrontOfHouseMealPlanSaga),
    fork(watchFoodPreOrderEventGroupPdfGuestListConfirmedSaga),
    fork(watchFoodPreOrderEventGroupPdfTablePlanListSaga),
    fork(watchFoodPreOrderEventGroupCsvKitchenMealPlanSaga),
    fork(watchFoodPreOrderEventGroupCsvFrontOfHouseMealPlanSaga),
    fork(watchFoodPreOrderEventGroupCsvGuestListConfirmedSaga),
    fork(watchFoodPreOrderEventGroupCsvTablePlanListSaga),
    fork(watchFoodPreOrderEventCsvKitchenMealPlanSaga),
    fork(watchFoodPreOrderEventCsvFrontOfHouseMealPlanSaga),
    fork(watchFoodPreOrderEventCsvGuestListConfirmedSaga),
    fork(watchFoodPreOrderEventGroupCsvDrinkListByTableSaga),
    fork(watchFoodPreOrderEventGroupPdfDrinkListByTableSaga),
    fork(watchFoodPreOrderSiteLocationSearchSaga),
    fork(watchFoodMenuCloneSaga),
  ]);
}
export default FoodPreOrderEventsSaga;
